import i18next from 'i18next';
import translation_en from './en.json';
import translation_nl from './nl.json';
import config from 'config';
import 'moment/locale/nl';
import 'moment/locale/en-au';
import moment from 'moment';

const buildType = config && config.type;
i18next.init(
  {
    lng: buildType === 'dev' ? 'en' : 'nl',
    fallbackLng: buildType === 'dev' ? 'en' : 'nl',
    resources: {
      en: {
        translation: translation_en
      },
      nl: {
        translation: translation_nl
      }
    },
    interpolation: {
      escapeValue: false // not needed for react!!
    },
    react: {
      wait: true,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      nsMode: 'default'
    }
  },
  () => {
    moment.locale(i18next.language);
  }
);

i18next.on('languageChanged', lng => {
  moment.locale(lng);
});

export default i18next;
